<h1 class="mb-2 mt-2">Sammelabrechner</h1>
<ebd-customer-form *ngIf="isEditing; else addCustomer" [customer$]="customer$" (saved)="finishEditCustomer($event)" (cancelled)="cancelEditCustomer()"></ebd-customer-form>
<ng-template #addCustomer>
  <div class="action-button-container">
    <input type="button" value="Neuer Sammelabrechner" (click)="startCreateCustomer()">
  </div>
</ng-template>
<hr>
<ebd-customers-list [customers$]="customers$" (customerEditing)="startEditCustomer($event)" (customerDeleting)="deleteCustomer($event)" [areActionsEnabled]="!isEditing"></ebd-customers-list>
